export default __webpack_public_path__ + "static/media/sheep.c07e5acc.svg";